import { EnvironmentInterface } from 'types/legacy/namespace';
import { ConnectionInfoDetails } from 'types/legacy/wireframe';

import { getPageScope, getServiceCode } from './getChatBotConfig';

export const hasChanges = (
    currentData: ConnectionInfoDetails,
    _env: EnvironmentInterface,
    data?: Partial<ConnectionInfoDetails>
) => {
    if (data) {
        if (data?.travelExpertIdHash) {
            return data.travelExpertIdHash !== currentData.travelExpertIdHash;
        } else if (data?.serviceCode) {
            return data.serviceCode !== currentData.serviceCode;
        } else if (data?.customer_input) {
            return data.customer_input !== currentData.customer_input;
        } else if (data?.offer) {
            return true;
        }
    } else {
        return (
            currentData.serviceCode !== getServiceCode() ||
            currentData.pageScope !== getPageScope()
        );
    }

    return false;
};
